module.exports = __webpack_public_path__ + "assets/img/modview.ec0f9cda.gif";